
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.container{
  display:grid;
  grid-template-columns:repeat(12, [col-start] 1fr);
  grid-template-rows:1fr;
  grid-column-gap:var(--grid-gap);
  grid-row-gap:0px;
}

.info{
  grid-column:col-start / span 6;
}

.logo{
  grid-column:col-start 8 / span 5;
  margin:0 auto;
}

.description,
.website,
.phone,
.category,
.social-icons{
  --sic-body-text--font-size:var(--body-03-font-size);
  padding-top:var(--spacing-08);
  color:var(--color-neutral-dark);
}

.description,
.website,
.phone{
  color:var(--color-neutral-default);
  font-size:var(--body-03-font-size);
}

.social-icons{
  max-width:50%;
  width:-moz-fit-content;
  width:fit-content;
}

slot[name='category']::slotted(div){
  display:flex;
  column-gap:var(--spacing-02);
  flex-wrap:wrap;
  row-gap:var(--spacing-01);
}

.is-mobile{
  display:flex;
  flex-direction:column;
  gap:var(--grid-gap);
}
`;